import { generatePath, useNavigate } from 'react-router-dom';

import { notify } from 'components/notification';
import { useAuth, useModalHandlers, useProfileQuery, useYaMeRolesQuery } from 'hooks';
import { ROUTE_PATHS } from 'settings';
import { replacePhotoSrcToSmall } from 'utils';

import {
  useNineBoxInformedMutation,
  useNotificationsQuery,
  useRiskRadarLogQuery,
} from '../../hooks';

function useTopNavigationContentHandlers() {
  const { id, signOut, roles } = useAuth();
  const { data: { photo, firstName, lastName } = {} } = useProfileQuery(id, {
    enabled: Boolean(id),
  });
  const { data: notifications = [], refetch: refetchNotifications } = useNotificationsQuery();
  const navigate = useNavigate();
  const handleSignOut = () => signOut();
  const navigateToProfile = () => {
    const path = generatePath(ROUTE_PATHS.ASSOCIATES.BY_ID.INDEX, {
      id,
    });

    navigate(path);
  };

  const { data: yaMeRoles } = useYaMeRolesQuery();
  const userRoles = yaMeRoles?.filter(({ identifier }) => roles?.includes(identifier)) || [];
  const { isOpenModal, closeModal, toggleModal } = useModalHandlers();

  const { refetch } = useRiskRadarLogQuery({
    enabled: false,
  });
  const { submitNineBoxInformed } = useNineBoxInformedMutation();

  const handleClickOnRiskRadarButton = () => refetch();

  const handleClickNineBoxInformed = (id: string) => {
    submitNineBoxInformed.mutate(
      { id },
      {
        onSuccess() {
          refetchNotifications();
          closeModal();
        },
        onError({ message }) {
          notify({ content: message, type: 'error' });
        },
      },
    );
  };

  return {
    handleSignOut,
    handleClickOnRiskRadarButton,
    handleClickNineBoxInformed,
    navigateToProfile,
    avatarSrc: replacePhotoSrcToSmall(photo || ''),
    userFullName: `${firstName || ''} ${lastName || ''}`,
    tooltipContent: userRoles.map(({ name }) => name).join(' | '),
    isMultipleRoles: userRoles.length > 1,
    notifications,
    isOpenModal,
    closeModal,
    toggleModal,
  };
}

export default useTopNavigationContentHandlers;
